exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._cLRe{margin-top:22px;position:relative;padding-bottom:30px}.LoC-5{-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:21px}.LoC-5,.tMNmo{display:-webkit-box;display:-ms-flexbox;display:flex}.tMNmo{font-size:30px;font-weight:800}._1mwcf{padding-right:20px;width:40px;height:40px;background:url(\"https://ydschool-video.nosdn.127.net/1727408085308%E5%8F%B3%E6%8C%89%E9%92%AE_%E9%BB%98%E8%AE%A4%401x+%281%29.png\") 50% no-repeat;background-size:40px;margin-left:auto}._1mwcf:hover{background:url(\"https://ydschool-video.nosdn.127.net/1727408085560%E7%82%B9%E5%87%BB%401x_%E5%89%AF%E6%9C%AC.png\") 50% no-repeat;background-size:40px}._1D4fM{display:inline-block;vertical-align:top;font-size:0;-webkit-transition:.3s;-o-transition:.3s;transition:.3s}._2lKKn{margin-right:20px}._1yT__,._2lKKn{border-radius:4px}._1yT__,._2lKKn,._35KoQ{display:inline-block;width:580px;height:288px}._35KoQ{vertical-align:top;margin-right:20px}", ""]);

// exports
exports.locals = {
	"root": "_cLRe",
	"titleRow": "LoC-5",
	"title": "tMNmo",
	"more": "_1mwcf",
	"headImgWrap": "_1D4fM",
	"headImg": "_2lKKn",
	"headImgSlide": "_1yT__",
	"sliderContainer": "_35KoQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_home/Section/index.css
// module id = 1234
// module chunks = 1